module.exports = __webpack_public_path__ + "img/submit.00751cc6.svg";